import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { errorMessageLogin } from "../../../common/errors";
import { FormLogin } from "../LoginPage.types";

const useLogin = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_URL

    return useMutation(async (formLogin: FormLogin) => {
        return await axios.post(`${baseUrl}auth/login`, formLogin)
    },
    {
        onSuccess: (res) => {
            const response = JSON.stringify(res.data.token)
            localStorage.setItem('token', response)
            queryClient.setQueryData('token', response)
            let token = JSON.parse(response || '{}')
            axios.get(`${baseUrl}user/me`, {headers: {Authorization: `Bearer ${token}`}}).then(res => {
                if (res.data.role?.type) {queryClient.setQueryData('role', res.data.role.type); queryClient.setQueryData('userData', res.data); localStorage.setItem("role", res.data.role.type); (res.data.role.type === "admin") ? navigate('/admin/users') : navigate('/dashboard/')}
                else {queryClient.setQueryData('role', 'user'); queryClient.setQueryData('userData', res.data); localStorage.setItem("role", "user"); navigate('/dashboard/')}
        })
        },
        onError: (err) => {console.log('Error:', err); errorMessageLogin()}
    });
};

export default useLogin;